'use strict';

const $ = require('jquery');

class Foundation {

    constructor() {

        let $container = $('.ce-content-tab-container');

        if ($container.length > 0) {

            $container.each(function () {

                let $this = $(this);
                let $accordionContentHolder = $this.find('[data-accordion-sidecontent]');
                let $firstItem = $this.find('.accordion-item').first();

                //  Click first item
                $firstItem.find('.accordion-title').trigger('click');

                $this.find('.accordion').on('down.zf.accordion', function (event, $target) {

                    //  Append long-content to holder
                    let itemHTML = $target.closest('li').find('.long-content').html();
                    $accordionContentHolder.html(itemHTML);

                    App.Globals.$window.trigger('reInitMagnificPopup');

                });

            });

        }

    }

}

module.exports = Foundation;
